import React from 'react'
import {GoogleMap} from '@react-google-maps/api';
import {MarkerF} from '@react-google-maps/api';
import Card from '@mui/material/Card';
import Link from '@mui/material/Link';
import SummaryBox from '../summary-box/SummaryBox';
import QuoteBox from '../quote-box/QuoteBox';
import {InfoWindowF} from '@react-google-maps/api';
import FloodMapLogic from './FloodMapLogic';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import './FloodMap.css';

const containerStyle = {
  width: '100vw',
  height: '100vh'
};

const FloodMap = (props) => {
  const {selectedEvent,setSelectedEvent,events,map,selectedSource,imageLocation,imagePath,link,dpLine,iFrameIsOpen,markerPoint,center,setSelectedSource,setiFrameIsOpen,onLoad,onUnmount,isInfowindowOpen,setIsInfowindowOpen,onInfowindowLoad,oniFrameWindowLoad,selectLatestTweet,open,handleClose} = FloodMapLogic(props)
  return (


    <Card id="map-container">
    
      {/* <Dialog onClose={handleClose} open={open}   style={{overflow: "hidden" }}>
        <IconButton id="close-button" onClick={handleClose}>
            <CloseIcon/>
        </IconButton>
        
        <div id="modal-title">
          <DialogTitle color="green" className='flood-fact' style={{fontSize:'medium',marginBottom:'-10px'}}>{props.address.split(',').slice(0,2).join(',')}</DialogTitle>
          
          <img alt="source Logo" style={{minWidth:'250px',minHeight:'250px'}} src='https://terracover.ai/flood-history/house-banners/test_house_overview.gif'/>
          
          <figcaption>Hurricane Harvey flooding</figcaption>
          
          <br></br>
          We found 16 reports related to flooding near this property.
        </div>
      </Dialog> */}

      <GoogleMap
        mapContainerStyle={containerStyle}
        map={map}
        center={center}
        zoom={17}
        onLoad={onLoad}
        onUnmount={onUnmount}
        options={{
          streetViewControl: false, // TODO: how to drop with flood polygons on roads
          rotateControl: false,
          fullscreenControl: false,
          zoomControlOptions: {
            position: window.google.maps.ControlPosition.TOP_RIGHT,
          },
          mapTypeId:'satellite',
           styles: [{ elementType: "labels", featureType: "poi", stylers: [{ visibility: "off", }], }],}}
        >
          
        <SummaryBox selectedEvent={selectedEvent} setSelectedEvent={setSelectedEvent} events={events} address={props.address} selectedSource={selectedSource} setSelectedSource={setSelectedSource} lat={props.coordinates.lat} lng={props.coordinates.lng}/>
        <QuoteBox address={props.address}/>
        <MarkerF 
          position={markerPoint}
          icon={{
            url: (require('../../../assets/home5.png')),
            fillColor: 'C1EE1A',
            scale: 20
          }}
        />

      {isInfowindowOpen  && (
        <div  style={{zIndex:100000}}>
        <InfoWindowF options={{'zIndex':10}} position={imageLocation} onCloseClick={() => setIsInfowindowOpen(false)} onLoad={onInfowindowLoad}>
          <div>
            <div >
              <img alt="source Logo" style={{marginRight:'5px'}} src={require(`../../../assets/${imagePath}.png`)}/><span STYLE="font-size:large;color:black"> " {dpLine} "</span>
            </div>
            <br></br>
            <Link  className="custom-link" target="_blank" href={`${link}`}  color="green" underline="none"><span STYLE="font-size:large;color:red">Read full article here</span></Link>
          </div>
        </InfoWindowF>
        </div>
        
      )}

    
      {iFrameIsOpen  && (  
        <InfoWindowF options={{maxWidth:'600px'}} position={imageLocation} onCloseClick={() => {setiFrameIsOpen(false)}} onLoad={oniFrameWindowLoad}>
          <div>
            {selectLatestTweet}
          </div>
        </InfoWindowF>
      
      )}

      </GoogleMap>
      
      </Card>
  ) 
}

export default React.memo(FloodMap)